import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

const base = `${baseUrl}`;

export function getCalendarEventsByMonth (token, month, year) {
    return axios.get(`${baseUrl}/events/${month}?year=${year}`, {
        headers: {
            authorization: token
        }
    });
}

export function updateCalendarEventById (token, id, data) {
    return axios.patch(`${baseUrl}/event/${id}`, data, {
        headers: {
            authorization: token
        }
    });
}

export function createCalendarEvent (token, data) {
    return axios.post(`${baseUrl}/event`, data, {
        headers: {
            authorization: token
        }
    });
}

export function deleteCalendarEventById (token, id) {
    return axios.delete(`${baseUrl}/event/${id}`, {
        headers: {
            authorization: token
        }
    });
}
